module.exports = __webpack_public_path__ + "media/images/athletes/2809-04a4af651d43735564168d95fcac3ae8.png";